import { get } from "lodash";
import { createSelector } from "reselect";

// -- STATE QUERIES -- //

const systemNotificationsQuery = state =>
  get(state, "systemNotifications.data", null);

// -- SELECTORS -- //

export const selectSystemNotification = createSelector(
  [systemNotificationsQuery],
  notification => {
    if (!notification || !notification.title || !notification.message)
      return null;

    return notification;
  }
);

// using the following export pattern so we can mock more easily using jest

const notificationSelectors = {
  selectSystemNotification
};

export default notificationSelectors;
